import { CSSRulesFunction, FontSize, ResponsiveValue } from '../../theme/types';
import {
  Color,
  FontFamilies,
  FontFamily,
  FontWeight,
  TextAlign,
  LetterSpacing,
  Display,
} from '../../theme/tokens';
import { CSSInterpolation } from '@emotion/serialize';

export interface AppearanceProps {
  fontFamily?: FontFamilies;
  fontWeight?: FontWeight;
  size?: ResponsiveValue<FontSize>;
  color?: ResponsiveValue<Color>;
  textAlign?: ResponsiveValue<TextAlign>;
  letterSpacing?: ResponsiveValue<LetterSpacing>;
  display?: ResponsiveValue<Display>;
}

export const textStyling: CSSRulesFunction<AppearanceProps> = (
  theme,
  props
) => {
  const color = theme.responsiveColor(props.color, ['color']);
  const font = theme.responsiveFont(props.size);
  const fontWeight = theme.responsiveStyle(
    props.fontWeight || FontWeight.Normal,
    ['fontWeight']
  );
  const textAlign = theme.responsiveStyle(props.textAlign || 'initial', [
    'textAlign',
  ]);
  const letterSpacing = theme.responsiveStyle(
    props.letterSpacing || LetterSpacing.Normal,
    ['letterSpacing']
  );
  const display = theme.responsiveStyle(props.display || Display.Block, [
    'display',
  ]);
  const fontFamilyProp = props.fontFamily || FontFamily.Mono;
  const fontFamily = theme.tokens.FontFamilies[fontFamilyProp];

  return [
    color,
    font,
    fontWeight,
    textAlign,
    letterSpacing,
    display,
    { margin: 0, fontFamily },
  ] as CSSInterpolation;
};
